var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconClassC(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Raggruppa_21552",
    "data-name": "Raggruppa 21552",
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    id: "Ellisse_1334",
    "data-name": "Ellisse 1334",
    cx: 10,
    cy: 10,
    r: 10,
    fill: "#c6e0b4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-check",
    "data-name": "Icon awesome-check",
    d: "M2.858,10.728.123,7.994a.421.421,0,0,1,0-.595L.718,6.8a.421.421,0,0,1,.595,0L3.155,8.646,7.1,4.7a.421.421,0,0,1,.595,0L8.29,5.3a.421.421,0,0,1,0,.595L3.452,10.728A.421.421,0,0,1,2.858,10.728Z",
    transform: "translate(6.25 2.422)",
    fill: "#75a758"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconClassC);
export default __webpack_public_path__ + "static/media/iconClassC.ac60a7a3af70750cb77c27bc66e3d391.svg";
export { ForwardRef as ReactComponent };